export default __webpack_public_path__ + "static/media/sabinestroh_neu.0521d79b.jpg";